module.exports = __webpack_public_path__ + "img/夢莎逆時雙效賦活露Ⅱ.90d78aa5.png";